import React from "react";
import { Field, reduxForm } from "redux-form";
import {database} from "../app-database";

class ConfidencialidadForm extends React.Component{

	state = {
		confidencialidad : ""
	}

	componentWillMount = () =>{
		var $this = this;
		database.ref("/documentacion/contrato").once("value").then(function(data){
			$this.setState({ "confidencialidad" : data.val() });  
		});
	}
	
	cancelar = () => {
		this.props.change("acepto", false);
		this.props.handleSubmit(values => this.props.onSubmit({ ...values, acepto: false }))();
	}
	
	aceptar = () => {
		this.props.change("acepto", true);
		this.props.handleSubmit(values => this.props.onSubmit({ ...values, acepto: true }))();
	}
	
	render() {
		const { handleSubmit, submitting } = this.props;
		return (
			<form onSubmit={handleSubmit}>
				<div className='text-content'>
					<div className="datos-wrap row">
						<div className="col-xs-12 datos-contrato" style={{ "height": "400px", "overflowY": "scroll" }}>
							<h3>Datos personales y Consentimiento</h3><br/>
							<div dangerouslySetInnerHTML={{__html: this.state.confidencialidad}} className="txt-gray"></div>
						</div>
					</div>
					<div className="text-center aceptar-cancelar-btn mt-75 xs-no-mt">
						<a onClick={this.cancelar}>No consiento</a>
						<a onClick={this.aceptar} >Sí consiento</a>
					</div>
				</div>
				<Field name="acepto" component="input" type="hidden" />
			</form>
		);
	}
}

export default ConfidencialidadForm = reduxForm({form: "confidencialidad"})(ConfidencialidadForm);


// WEBPACK FOOTER //
// ./src/contrato/confidencialidad.frm.js